<template>
    <div>
        <b-toast :visible="true" :title="$t('toast_admin_message')" no-auto-hide :toaster="toaster">
            <div class="body-wrapper">
                {{msg}}
            </div>
        </b-toast>
    </div>
</template>

<script>
export default {
	props: {msg: String},
	data: () => ({
		toaster: "toolbar_crm_intergration_toaster"
	})
};
</script>